<section class="countdown-timer"
     [class.warn]="percentRemaining() <= warnThresholdPercent()"
     [class.danger]="percentRemaining() <= dangerThresholdPercent()">
  <div class="timer-display">
    @if (secondsRemaining() > 0) {
      <span class="timer-label">{{ label() }}</span>
      <span class="timer-value">{{ formattedTime() }}</span>
    } @else {
      <span class="timer-label text-danger">{{ expiredLabel() }}</span>
    }
  </div>
  <div class="timer-progress">
    <div class="timer-bar" [ngClass]="{'animated': animate()}" [style.width.%]="progressPercent()"></div>
  </div>
</section>
